// import React, { useEffect, useState } from "react";
// import DeliveryHeader from "./DeliveryHeader";
// import "./DeliveryLogin.css";
// import {
//   Button,
//   Col,
//   Container,
//   Form,
//   Modal,
//   Row,
//   Spinner,
//   Table,
// } from "react-bootstrap";
// import axios from "axios";
// import { toast } from "react-toastify";
// import { Autocomplete, Paper, TextField } from "@mui/material";
// import {
//   CustomerFindAll,
//   DeliveryDashboarConfirm,
//   DeliveryDashboardAdd,
//   DeliveryDashboardAddOuter,
//   DeliveryDashboardDelete,
//   DeliveryDashboardFindAll,
//   DeliveryDashboardOuterFindAll,
//   DeliveryDashboardUpdate,
//   DeliveryProductFindAll1,
//   EmployeeFindAll,
//   ProductFindAll,
// } from "../Admin/API/Api";
// import FormControl from "@mui/material/FormControl";
// // import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// // import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// // import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// // import dayjs from "dayjs";

// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
// import dayjs from 'dayjs';

// const DeliveryDashboard = () => {
//   const userdata = JSON.parse(sessionStorage.getItem("userdata"));
//   console.log("userdata console....", userdata);
//   const employeeid = userdata.employee_id;
//   const BranchId = userdata.branch_id;
//   const [selectedCustomerName, setSelectedCustomerName] = useState("");
//   const [isEditing, setisEditing] = useState(false);
//   const [show, setShow] = useState(false);
//   const [data, setData] = useState([]);
//   const [orderData, setOrderData] = useState([]);
//   const [orderId, setOrderId] = useState();
//   const [id, setId] = useState();
//   const [product_master, setProduct_master] = useState([]);
//   const [employee_master, setEmployee_master] = useState([]);
//   const [customer_master, setCustomer_master] = useState([]);
//   const [productId, setProductId] = useState();
//   const [employeeId, setEmployeeId] = useState();
//   const [customerId, setCustomerId] = useState();
//   const [quantity, setQuantity] = useState();
//   const [amount, setAmount] = useState();
//   const [date, setDate] = useState(dayjs());
//   const [user, setUser] = useState(null);
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const handleClose = () => setShow(false);
//   const handleShow = (item) => {
//     setSelectedCustomerName(item.customer_name);
//     // setOrderId(item.order_id);
//     setId(item.id);
//     setCustomerId(item.customer_id);
//     setEmployeeId(item.employee_id);
//     setQuantity(item.quantity);
//     setAmount(item.amount);
//     setShow(true);
//   };
//   const [showEdit, setShowEdit] = useState(false);

//   // =========== delete modal =========
//   const [show1, setShow1] = useState(false);
//   const handleClose1 = () => setShow1(false);

//   const [itemToDelete, setItemToDelete] = useState(null);

//   const handleShow1 = (item) => {
//     setItemToDelete(item);
//     setShow1(true);
//   };

//   useEffect(() => {
//     window.history.pushState(null, document.title, window.location.href);
//     window.addEventListener('popstate', function (event) {
//         window.history.pushState(null, document.title, window.location.href);
//     });

//     return () => {
//         window.removeEventListener('popstate', function (event) {
//             window.history.pushState(null, document.title, window.location.href);
//         });
//     };
// }, []);

//   //  =========== Edit ======
//   const handleEditClose = () => {
//     setShowEdit(false);
//     setId("");
//     setProductId("");
//     setQuantity("");
//     setAmount("");
//   };

//   const setEditDataFun = (item) => {
//     setProductId(item.product_id);
//     setCustomerId(item.customer_id);
//     setQuantity(item.quantity);
//     setAmount(item.rate);
//     setId(item.id);
//     setisEditing(true);
//   };

//   //   ================= Apply Order ==========================
//   const saveemp = (e) => {
//     setLoading(true);
//     e.preventDefault();
//     if (!date) {
//       alert("Select  Date......!");
//       return;
//     }
//     console.log("orderData:", orderData);
//     if (!orderData || !Array.isArray(orderData)) {
//       console.error("Invalid orderData");
//       return;
//     }

//     const resultArray = orderData.map((item) => {
//       if (!item) {
//         console.error("Invalid item in orderData:", item);
//         return null;
//       }
//       const productPairs = item.product_quantity.split(",");

//       const productData = productPairs.map((pair) => {
//         const [productId, quantity] = pair.split("-");
//         const formattedDate = dayjs(date).format("DD/MM/YYYY");
//         return {
//           customer_id: item.customer_id,
//           date: item.date,
//           employee_id: item.employee_id,
//           order_id: item.order_id,
//           product_id: productId,
//           quantity: parseInt(quantity, 10),
//         };
//       });

//       const formattedDate = dayjs(date).format("DD/MM/YYYY");
//       return {
//         employee_id: item.employee_id,
//         date: formattedDate,
//         branch_id: BranchId,
//         items: productData, 
//       };
//     });

//     const validResultArray = resultArray.filter((item) => item !== null);
//     const resultDataMap = new Map();

//     validResultArray.forEach((entry) => {
//       const key = `${entry.employee_id}-${entry.date}`;

//       if (!resultDataMap.has(key)) {
//         resultDataMap.set(key, {
//           employee_id: entry.employee_id,
//           branch_id: BranchId,
//           date: entry.date,
//           items: [],
//         });
//       }

//       resultDataMap.get(key).items.push(...entry.items);
//     });

//     const resultDataArray = Array.from(resultDataMap.values());

//     console.log("add resultarray....", resultDataArray[0]);
//     axios
//       .post(DeliveryDashboardAddOuter, resultDataArray[0])
//       .then((res) => {
//         console.log("console res add api", res);
//         console.log("outer data add", res.data);
//         if (res.data === "SAVED") {
//           toast.success("Apply Successfully.", {
//             position: "top-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//           GetOrderdata();
//           // setEmployeeId("");
//           // setId("");
//           setLoading(false);
//         } else if (res.data === "DATE_ALREADYEXIST") {
//           toast.info("Date already exists.", {
//             position: "top-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//           setLoading(false);
//         } else if (res.data === "NOTFOUND") {
//           toast.info("Product not found.", {
//             position: "top-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//           setLoading(false);
//         } else if (
//           res.data.message === "Date cannot be greater than the current date"
//         ) {
//           toast.error("Date cannot be greater than the current date", {
//             position: "top-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//           setLoading(false);
//         }
//       })
//       .catch((err) => {
//         toast.error("Failed to upload, please try again", {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
        
//         console.error(err);
//       });
//       setLoading(false);
//   };

//   //  ================  inner table save api =====================

//   const savedata = (e) => { 
//     e.preventDefault();
//     setLoading(true);
//     if (!quantity || !productId) {
//       alert("Please fill in all fields");
//       return;
//     }
//     // const formattedDate = dayjs(date).format('YYYY-MM-DD');

//     if (!date) {
//       console.error("Invalid date:", date);
//       // Handle the invalid date case, for example, by showing an error message
//       return;
//     }
//     const formattedDate = dayjs(date).format("DD/MM/YYYY");
//     const obj = {
//       employee_id: employeeId,
//       product_id: productId,
//       quantity: quantity,
//       date: formattedDate,
//       branch_id: BranchId,
//     };
//     console.log("FormData", obj);

//     axios
//       .post(`${DeliveryDashboardAdd}${customerId}`, obj)
//       .then((res) => {
//         console.log("save data ///..", res.data);
//         if (res.data.message === "SAVED") {
//           console.log("res.data", res.data);
//           toast.success("Data Saved Successfully!", {
//             position: "top-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//           // Reset form fields and reload the data
//           Getdata();
//           GetOrderdata();
//           setProductId("");
//           setAmount("");
//           setQuantity("");
//           setId("");
//           setLoading(false);
//           // setDate('');
//           // setShow(false);
//           // window.location.reload(); // Note: Reloading the entire page may not be the best practice, consider updating the data from the API.
//         } else if (res.data === "ALREADYEXIST") {
//           toast.info("Data already exists.", {
//             position: "top-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//           setLoading(false);
//         } else if (res.data === "NOTFOUND") {
//           toast.info("Product not found.", {
//             position: "top-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//           setLoading(false);
//         } else if (res.data === "not_orderAllotment") {
//           toast.info("Data not found.", {
//             position: "top-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//           setLoading(false);
//         }
//       })
//       .catch((err) => {
//         toast.error("Failed to upload, please try again", {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
//         setLoading(false);
//         console.error(err);
//       });
//   };

//   const handleConfirm = () => {
//     console.log(`${DeliveryDashboarConfirm}/${date}/${employeeId}/${BranchId}`);

//     axios
//       .get(`${DeliveryDashboarConfirm}/${date}/${employeeId}/${BranchId}`)
//       .then((response) => {
//         // Handle the response as needed
//         console.log("Confirm API response:", response.data);
//         toast.success("Data Confirmed Successfully!", {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
//         handleClose();
//         // You may want to perform additional actions after confirming data
//       })
//       .catch((error) => {
//         console.error("Error confirming data:", error);
//         toast.error("Failed to confirm data, please try again", {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
//       });
//   };

//   //Getdata Logic
//   const Getdata = (e) => {
//     if (!customerId) {
//       // customerId is not set, handle accordingly
//       return;
//     }
//     if (!date) {
//       console.error("Invalid date:", date);
//       // Handle the invalid date case, for example, by showing an error message
//       return;
//     }
//     const formattedDate = dayjs(date).format("DD/MM/YYYY");
//     const obj = {
//       customer_id: customerId,
//       date: formattedDate,
//       branch_id: BranchId,
//     };
//     console.log("inner table FormData.....", obj);
//     console.log("date inner.....", formattedDate);

//     axios
//       .post(DeliveryDashboardFindAll, obj)

//       .then((res) => {
//         console.log("findal inner table", res.data);
//         if (res.data !== null) {
//           setData(res.data);
//         }
//         setisEditing(false);
//       })
//       .catch((err) => {
//         // alert("Failed to upload, try again");
//         toast.error("Failed to upload, try again", {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
//         console.log(err);
//       });
//   };

//   const GetOrderdata = () => {
//     if (!date) {
//       // Handle the case when date is not set
//       return;
//     }
//     const formattedDate = dayjs(date).format("DD/MM/YYYY");
//     setOrderData([]);
//     const obj = {
//       employee_id: employeeid,
//       date: formattedDate,
//       branch_id: BranchId,
//     };
//     console.log("outer table FormData", obj);
//     console.log("outer table date", formattedDate);
// if(formattedDate === "Invalid Date"){}else{
//     axios
//       .post(DeliveryDashboardOuterFindAll, obj)
//       .then((res) => {
//         console.log("findall outer====", res.data);
//         if (res.data.length === 0) {
//           toast.warn("Data Not Allocated...");
//         } else if (res.data !== null) {
//           setOrderData(res.data);
//         }
//         setisEditing(false);
//       })
//       .catch((err) => {
//         // alert("Failed to upload, try again");
//         toast.error("Failed to upload, try again", {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
//         console.log(err);
//       });}
//   };

//   const updateDeliveryDashboard = () => {
//     setLoading(true);
//     if (!selectedCustomerName || !productId || !quantity || !customerId) {
//       alert("Please fill in all the fields");
//       return;
//     }
//     const formattedDate = dayjs(date).format("DD/MM/YYYY");
//     const formData = {
//       customer_id: customerId,
//       product_id: productId,
//       quantity: quantity,
//       date: formattedDate,
//     };
//     console.log("update console obj....", formData);

//     axios
//       .put(`${DeliveryDashboardUpdate}${id}`, formData)

//       .then((res) => {
//         console.log("order update res....", res.data);
//         if (res.data.message === "UPDATE") {
//           toast.success("Data Updated Successfully!", {
//             position: "top-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//           Getdata();
//           GetOrderdata();
//           setLoading(false);

//           handleEditClose();
//         } else if (res.data === "ALREADYEXIST") {
//           toast.info("Data already exists.", {
//             position: "top-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//           setLoading(false);
//         }
//       })
//       .catch((err) => {
//         // Add debugging information to identify the issue
//         console.error("Error while updating Employee:", err);
//         setLoading(false);
//         if (err.response) {
//           console.error("Response data:", err.response.data);
//         }

//         toast.error("Failed to update data, please try again", {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
//         setLoading(false);
//       });
//   };

//   useEffect(() => {
//     if (show) {
//       // Reload data when the modal is shown
//       Getdata();
//     }
//   }, [show, customerId, employeeId, date]);

//   //delete data
//   const onDelete = (item) => {
//     console.log("deleting items...", item);

//     axios
//       .delete(`${DeliveryDashboardDelete}${item.id}`)
//       .then((res) => {
//         console.log("Delete response:", res);
//         if (res.data === "DELETE") {
//           // alert("File Deleted Succesfully");
//           toast.success("Data Deleted Succesfuly!", {
//             position: "top-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//         }
//         handleClose1(false);
//         Getdata();
//         GetOrderdata();
//       })
//       .catch((err) => {
//         // alert("Failed to upload, try again");
//         console.log("Error deleting item:", err);
//         toast.error("Failed to upload, try again", {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
//         console.log(err);
//       });
//   };

//   useEffect(() => {
//     Getdata();
//     GetOrderdata();
//   }, [customerId, date]);

//   //CustomerData Logic
//   const Customerdata = (e) => {
//     axios
//       .get(`${CustomerFindAll}/${BranchId}`)
//       .then((res) => {
//         if (res.data !== null) {
//           setCustomer_master(res.data);
//         }
//         setisEditing(false);
//       })
//       .catch((err) => {
//         // alert("Failed to upload, try again");
//         toast.error("Failed to upload, try again", {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
//         console.log(err);
//       });
//   };

//   //Product Logic
//   const Productdata = (e) => {
//     axios
//       .get(`${DeliveryProductFindAll1}/${BranchId}`)
//       .then((res) => {
//         if (res.data !== null) {
//           setProduct_master(res.data);
//         }
//         setisEditing(false);
//       })
//       .catch((err) => {
//         // alert("Failed to upload, try again");
//         toast.error("Failed to upload, try again", {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
//         console.log(err);
//       });
//   };

//   //Employeedata Logic
//   const Employeedata = (e) => {
//     axios
//       .get(`${EmployeeFindAll}/${BranchId}`)
//       .then((res) => {
//         if (res.data !== null) {
//           setEmployee_master(res.data);
//         }
//         setisEditing(false);
//       })
//       .catch((err) => {
//         // alert("Failed to upload, try again");
//         toast.error("Failed to upload, try again", {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
//         console.log(err);
//       });
//   };

//   useEffect(() => {
//     if (isEditing === false) {
//       Getdata();
//       GetOrderdata();
//       Productdata();
//       Customerdata();
//       Employeedata();
//     }
//   }, [isEditing]);

//   //HEADING FONT ===================

//   const headingStyle = {
//     fontSize: "27px",
//     fontWeight: "bold",
//     textAlign: "center",
//   };

//   const subheadingStyle = {
//     color: "rgb(255, 93, 0)", // Assuming this is the color for "text-violet-800"
//     fontWeight: 300, // Assuming this is the font weight for "font-[300]"
//     textShadow: "3px 1px 5px rgb(180, 180, 180)",
//   };
//   const uniqueCustomerIds = new Set();

//   return (
//     <Container fluid>
//       <Row>
//         {" "}
//         <DeliveryHeader />{" "}
//       </Row>

//       <Row className="BgImg px-md-5">
//         {/* ====================== table =============== */}
//         <Row
//           className="m-0 p-0  px-md-5  py-1 mb-5  w-100"
//           style={{ display: "flex" }}
//         >
//           <Row className="pt-3">
//             <div style={{display:"flex",justifyContent:"center",textShadow:"3px 1px 5px rgb(180, 180, 180)",color: "rgb(255, 93, 0)", fontWeight: "400"}}><h3 className="mt-2 "> Dashboard</h3></div>
//           </Row>
//           <Row className="m-0 p-0">
//             <Col sm={12} md={8}></Col>
//             <Col
//               sm={12}
//               md={4}
//               style={{ display: "flex", justifyContent: "end" }}
//             >
//               <Col>
               
//               <LocalizationProvider dateAdapter={AdapterDayjs}>
//   <DemoContainer components={['DatePicker']}>
//     <DatePicker
//       format="DD-MM-YYYY"
//       label="Select Date"
//       value={date}
//       onChange={(newDate) => {
//         console.log("date res", newDate);
//         setDate(newDate);
//       }}
//       slotProps={{ textField: { size: 'small' } }}
//     />
//   </DemoContainer>
// </LocalizationProvider>

//               </Col>

//               <Col  style={{ display: "flex", alignItems: "center" }}>
//                 <Button
//                   style={{
//                     border: "0px",
//                     backgroundColor: "lightcoral",
//                     borderRadius: "15px",
//                   }}
//                   className="py-2 mt-1 px-2 ms-3 fw-1 mx-2 shadow text-dark "
//                   type="submit"
//                   onClick={saveemp}
//                   disabled={loading}
//                     >{loading ? <Spinner animation='border' size='sm' variant="primary" /> : <div>
                     
//                     Apply Order</div>}
//                 </Button>
//               </Col>
//             </Col>
//           </Row>

//           <div style={{ overflowY: "auto" }}>
//             <div style={{ overflowX: "auto" }}>
//               <Table
//                 striped
//                 bordered
//                 hover
//                 size="sm"
//                 className="shadow mt-4"
//                 style={{ textAlign: "center" }}
//               >
//                 <thead>
//                   <tr>
//                     <th
//                       style={{
//                         alignItems: "center",
//                         backgroundColor: "darkslategray",
//                         fontSize: "13px",
//                         fontFamily: "sans-serif",
//                       }}
//                       className="text-center text-light"
//                     >
//                       Sr.No
//                     </th>
//                     <th
//                       style={{
//                         alignItems: "center",
//                         backgroundColor: "darkslategray",
//                         fontSize: "13px",
//                         fontFamily: "sans-serif",
//                       }}
//                       className="text-center text-light"
//                     >
//                       Customer
//                     </th>
//                     <th
//                       style={{
//                         alignItems: "center",
//                         backgroundColor: "darkslategray",
//                         fontSize: "13px",
//                         fontFamily: "sans-serif",
//                       }}
//                       className="text-center text-light"
//                     >
//                       Product & Quantity Regular
//                     </th>
//                     <th
//                       style={{
//                         alignItems: "center",
//                         backgroundColor: "darkslategray",
//                         fontSize: "13px",
//                         fontFamily: "sans-serif",
//                       }}
//                       className="text-center text-light"
//                     >
//                       Product & Quantity Today
//                     </th>
//                     <th
//                       style={{
//                         alignItems: "center",
//                         backgroundColor: "darkslategray",
//                         fontSize: "13px",
//                         fontFamily: "sans-serif",
//                       }}
//                       className="text-center text-light"
//                     >
//                       Change
//                     </th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {orderData.map((item, index) => {
//                     const productQuantities = item.productquantity
//                       ? item.productquantity.split(",")
//                       : [];
//                     const backgroundColors = [
//                       "Tomato",
//                       "cadetblue ",
//                       "orchid",
//                       "peru",
//                       "mediumturquoise",
//                       "skyblue",
//                       "yellowgreen",
//                     ];

//                     const productQuantities1 = item.updateproduct
//                       ? item.updateproduct.split(",")
//                       : [];

//                     const groupedProductQuantities = orderData.reduce(
//                       (result, order) => {
//                         if (!result[order.customer_id]) {
//                           result[order.customer_id] = [];
//                         }
//                         result[order.customer_id].push(order.productquantity);
//                         return result;
//                       },
//                       {}
//                     );

//                     const groupedProductQuantities1 = orderData.reduce(
//                       (result, order) => {
//                         if (!result[order.customer_id]) {
//                           result[order.customer_id] = [];
//                         }
//                         result[order.customer_id].push(order.updateproduct);
//                         return result;
//                       },
//                       {}
//                     );

//                     const customerProductQuantities =
//                       groupedProductQuantities[item.customer_id] || [];
//                     const customerProductQuantities1 =
//                       groupedProductQuantities1[item.customer_id] || [];

//                     const flattenedProductQuantities =
//                       customerProductQuantities.flat();
//                     const flattenedProductQuantities1 =
//                       customerProductQuantities1.flat();

//                     // Check if customer ID is already processed, skip if it is
//                     if (uniqueCustomerIds.has(item.customer_id)) {
//                       return null;
//                     }

//                     // Add the current customer ID to the set to mark it as processed
//                     uniqueCustomerIds.add(item.customer_id);

//                     return (
//                       <tr
//                         className="border"
//                         style={{
//                           width: "100%",
//                           justifyContent: "center",
//                           alignContent: "center",
//                         }}
//                         key={index}
//                       >
//                         <td style={{ textAlign: "center", width: "10%" }}>
//                           {index + 1}
//                         </td>
//                         <td
//                           style={{
//                             textAlign: "center",
//                             whiteSpace: "nowrap",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             width: "30%",
//                           }}
//                         >
//                           {item.customer_name}
//                         </td>
//                         <td
//                           className="text-center pt-2"
//                           style={{
//                             textAlign: "center",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             whiteSpace: "nowrap",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             width: "40%",
//                           }}
//                         >
//                           {flattenedProductQuantities.map((productQty, idx) => (
//                             <span
//                               key={idx}
//                               style={{
//                                 backgroundColor:
//                                   backgroundColors[
//                                     idx % backgroundColors.length
//                                   ],
//                                 padding: "5px 10px",
//                                 margin: "0px 5px",
//                                 borderRadius: "10px",
//                                 color: "black",
//                               }}
//                             >
//                               {productQty.trim()}
//                               {idx < flattenedProductQuantities.length - 1 && (
//                                 <span style={{ margin: "0 5px" }}></span>
//                               )}
//                             </span>
//                           ))}
//                         </td>
//                         <td
//                           className="text-center pt-2"
//                           style={{
//                             textAlign: "center",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             whiteSpace: "nowrap",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             width: "40%",
//                           }}
//                         >
//                           {flattenedProductQuantities1.map(
//                             (productQty1, idx) => (
//                               <span
//                                 key={idx}
//                                 style={{
//                                   backgroundColor:
//                                     backgroundColors[
//                                       idx % backgroundColors.length
//                                     ],
//                                   padding: "5px 10px",
//                                   margin: "0px 5px",
//                                   borderRadius: "10px",
//                                   color: "black",
//                                 }}
//                               >
//                                 {productQty1.trim()}
//                                 {idx <
//                                   flattenedProductQuantities1.length - 1 && (
//                                   <span style={{ margin: "0 5px" }}></span>
//                                 )}
//                               </span>
//                             )
//                           )}
//                         </td>
//                         <td style={{ textAlign: "center", width: "20%" }}>
//                           <button
//                             className=" m-1"
//                             style={{
//                               color: "orange",
//                               border: "0px",
//                               backgroundColor: "transparent",
//                             }}
//                             onClick={() => handleShow(item)}
//                           >
//                             <i
//                               style={{ color: "rgb(255, 93, 0)" }}
//                               className="fa-solid fa-plus"
//                             ></i>
//                           </button>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </Table>
//             </div>
//           </div>

//         </Row>

//         {/* ========================== Modal ============= */}
//         <Modal
//           className="shadow rounded"
//           size="xl"
//           show={show}
//           onHide={handleClose}
//         >
      
//           <Modal.Body>
//             <Form encType="multipart/form-data">
//               <Row className="m-0 p-0">
//                 <Col sm={12} md={4} className="mt-3">
//                   <Form.Label>
//                     <h6>
//                       <b>Customer :</b>
//                     </h6>
//                   </Form.Label>
//                   <TextField
//                     size="small"
//                     type="text"
//                     readOnly
//                     value={selectedCustomerName}
//                     style={{ width: "100%" }} 
//                   />
//                 </Col>

//                 <Col sm={12} md={4} className="mt-3">
//                   <Form.Label>
//                     <h6>
//                       <b>Product :</b>
//                     </h6>
//                   </Form.Label>
                 
//                   <Autocomplete
//                     disablePortal
//                     size="small"
//                     id="combo-box-demo"
//                     options={product_master}
//                     getOptionLabel={(option) => option.product_name}
//                     value={
//                       product_master.find(
//                         (item) => item.product_id === productId
//                       ) || null
//                     }
//                     onChange={(e, newValue) =>
//                       setProductId(newValue ? newValue.product_id : "")
//                     }
//                     renderInput={(params) => (
//                       <TextField
//                         {...params}
//                         label="Select Product"
//                         style={{ width: "100%" }}
//                       />
//                     )} 
//                   />
//                   {/* )} */}
//                 </Col>

//                 <Col sm={12} md={4} className="mt-3 mb-3">
//                   <Form.Label>
//                     <h6>
//                       <b>Quantity :</b>
//                     </h6>
//                   </Form.Label>
//                   <TextField
//                     size="small"
//                     type="number"
//                     placeholder="Enter Quantity"
//                     pattern="[0-9]"
//                     required
//                     value={quantity}
//                     onChange={(e) => setQuantity(e.target.value)}
//                     style={{ width: "100%" }} 
//                   />
//                 </Col>
//               </Row>
//               <Row className="mt-2 mb-3">
//                 <Col style={{ display: "flex", justifyContent: "center" }}>
//                   {isEditing === false ? (
//                     <Button
//                       style={{
//                         border: "0px",
//                         backgroundColor: "rgb(47, 79, 79)",
//                         borderRadius: "15px",
//                       }}
//                       className="py-2 px-3 mx-2 shadow text-light"
//                       type="submit"
//                       onClick={savedata}
//                     disabled={loading}
//                     >{loading ? <Spinner animation='border' size='sm' variant="primary" /> : <div>
                     
//                       &nbsp;Save</div>}
//                     </Button>
//                   ) : (
//                     <Button
//                       style={{
//                         border: "1px solid rgb(47, 79, 79)",
//                         backgroundColor: "rgb(47, 79, 79)",
//                         borderRadius: "15px",
//                       }}
//                       className="py-2 px-3 mx-2 shadow text-light"
//                       type="submit"
//                       onClick={updateDeliveryDashboard}
//                       disabled={loading}
//                     >{loading ? <Spinner animation='border' size='sm' variant="primary" /> : <div>
                     
//                       &nbsp;Update</div>}
                      
//                     </Button>
//                   )}
//                 </Col>
//               </Row>
//             </Form>

//             <div style={{ overflowY: "auto" }}>
//               <div style={{ overflowX: "auto" }}>
//                 <Table
//                   striped
//                   bordered
//                   hover
//                   size="sm"
//                   className="shadow mt-2"
//                   style={{ textAlign: "center" }}
//                 >
//                   <thead>
//                     <tr>
//                       <th
//                         style={{
//                           alignItems: "center",
//                           backgroundColor: "darkslategray",
//                           fontSize: "13px",
//                           fontFamily: "sans-serif",
//                         }}
//                         className="text-center text-light"
//                       >
//                         Sr.No
//                       </th>
//                       <th
//                         style={{
//                           alignItems: "center",
//                           backgroundColor: "darkslategray",
//                           fontSize: "13px",
//                           fontFamily: "sans-serif",
//                         }}
//                         className="text-center text-light"
//                       >
//                         Customer
//                       </th>
//                       <th
//                         style={{
//                           alignItems: "center",
//                           backgroundColor: "darkslategray",
//                           fontSize: "13px",
//                           fontFamily: "sans-serif",
//                         }}
//                         className="text-center text-light"
//                       >
//                         Product
//                       </th>
//                       <th
//                         style={{
//                           alignItems: "center",
//                           backgroundColor: "darkslategray",
//                           fontSize: "13px",
//                           fontFamily: "sans-serif",
//                         }}
//                         className="text-center text-light"
//                       >
//                         Quantity
//                       </th>
//                       <th
//                         style={{
//                           alignItems: "center",
//                           backgroundColor: "darkslategray",
//                           fontSize: "13px",
//                           fontFamily: "sans-serif",
//                         }}
//                         className="text-center text-light"
//                       >
//                         Edit
//                       </th>
//                       <th
//                         style={{
//                           alignItems: "center",
//                           backgroundColor: "darkslategray",
//                           fontSize: "13px",
//                           fontFamily: "sans-serif",
//                         }}
//                         className="text-center text-light"
//                       >
//                         Delete
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {data.map((item, index) => {
//                       return (
//                         <tr className="border">
//                           <td style={{ textAlign: "center" }}>{index + 1}</td>
//                           <td style={{ textAlign: "center" }}>
//                             {item.customer_name}
//                           </td>
//                           <td style={{ textAlign: "center" }}>
//                             {item.product_name}
//                           </td>
//                           <td style={{ textAlign: "center" }}>
//                             {item.quantity}
//                           </td>
//                           <td style={{ textAlign: "center" }}>
//                             <button
//                               className=" m-1"
//                               style={{
//                                 color: "orange",
//                                 border: "0px",
//                                 backgroundColor: "transparent",
//                               }}
//                               onClick={() => setEditDataFun(item)}
//                             >
//                               <i class="fa-solid fa-pen-to-square"></i>
//                             </button>
//                           </td>

//                           <td style={{ textAlign: "center" }}>
//                             <button
//                               className=" m-1"
//                               style={{
//                                 color: "red",
//                                 border: "0px",
//                                 backgroundColor: "transparent",
//                               }}
//                               onClick={() => handleShow1(item)}
//                             >
//                               <i className="fa-solid fa-trash"></i>
//                             </button>
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </Table>
//               </div>
//             </div>
//           </Modal.Body>

//           <Modal.Footer
//             className="m-0 p-0"
//             style={{ backgroundColor: " rgb(47, 79, 79)" }}
//           >
//             {/* <Button style={{ color: "white", backgroundColor: "darkslategray", border: "2px solid darkslategray", borderRadius: "15px" }} onClick={handleConfirm}>
//               Confirm
//             </Button> */}

//             <Button
//               style={{
//                 color: "black",
//                 backgroundColor: "white",
//                 border: "2px solid white",
//                 borderRadius: "15px",
//               }}
//               onClick={handleClose}
//             >
//               Close
//             </Button>
//           </Modal.Footer>
//         </Modal>

//         {/* ============= Delete Modal ========= */}

//         <Modal show={show1} onHide={handleClose1}>
//           <Modal.Header
//             style={{ backgroundColor: " rgb(47, 79, 79)", color: "White" }}
//           >
//             <Modal.Title>
//               <i
//                 className="fa-solid fa-trash"
//                 style={{ color: "rgb(254, 105, 129)" }}
//               ></i>{" "}
//               Delete Confirmation
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>Are you sure you want to delete this item?</Modal.Body>
//           <p className="text-end">
//             <Button
//               className="mx-2"
//               style={{
//                 color: "black",
//                 backgroundColor: "white",
//                 border: "2px solid darkslategray",
//                 borderRadius: "15px",
//               }}
//               onClick={handleClose1}
//             >
//               Cancel
//             </Button>
//             <Button
//               style={{
//                 border: "1px solid darkslategray",
//                 backgroundColor: "darkslategray",
//                 borderRadius: "15px",
//               }}
//               className="py-2 px-3 mx-2  shadow text-light"
//               onClick={() => onDelete(itemToDelete)}
//             >
//               Delete
//             </Button>
//           </p>
//         </Modal>
//       </Row>
//     </Container>
//   );
// };

// export default DeliveryDashboard;







import React, { useEffect, useState } from "react";
import DeliveryHeader from "./DeliveryHeader";
import "./DeliveryLogin.css";
import {
  Button,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { Autocomplete, Paper, TextField } from "@mui/material";
import {
  CustomerFindAll,
  DeliveryDashboarConfirm,
  DeliveryDashboardAdd,
  DeliveryDashboardAddOuter,
  DeliveryDashboardDelete,
  DeliveryDashboardFindAll,
  DeliveryDashboardOuterFindAll,
  DeliveryDashboardUpdate,
  DeliveryProductFindAll1,
  EmployeeFindAll,
  ProductFindAll,
} from "../Admin/API/Api";
import FormControl from "@mui/material/FormControl";
import { MDBDataTable } from 'mdbreact';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';

const DeliveryDashboard = () => {
  const userdata = JSON.parse(sessionStorage.getItem("userdata"));
  console.log("userdata console....", userdata);
  const employeeid = userdata.employee_id;
  const BranchId = userdata.branch_id;
  const [selectedCustomerName, setSelectedCustomerName] = useState("");
  const [isEditing, setisEditing] = useState(false);
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [orderId, setOrderId] = useState();
  const [id, setId] = useState();
  const [product_master, setProduct_master] = useState([]);
  const [employee_master, setEmployee_master] = useState([]);
  const [customer_master, setCustomer_master] = useState([]);
  const [productId, setProductId] = useState();
  const [employeeId, setEmployeeId] = useState();
  const [customerId, setCustomerId] = useState();
  const [quantity, setQuantity] = useState();
  const [amount, setAmount] = useState();
  const [date, setDate] = useState(dayjs());
  const [user, setUser] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleClose = () => setShow(false);

  const handleShow = (item) => {
    setSelectedCustomerName(item.customer_name);
    // setOrderId(item.order_id);
    setId(item.id);
    setCustomerId(item.customer_id);
    setEmployeeId(item.employee_id);
    setQuantity(item.quantity);
    setAmount(item.amount);
    setShow(true);
  };

  const [showEdit, setShowEdit] = useState(false);

  // =========== delete modal =========
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);

  const [itemToDelete, setItemToDelete] = useState(null);

  const handleShow1 = (item) => {
    setItemToDelete(item);
    setShow1(true);
  };

  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', function (event) {
        window.history.pushState(null, document.title, window.location.href);
    });

    return () => {
        window.removeEventListener('popstate', function (event) {
            window.history.pushState(null, document.title, window.location.href);
        });
    };
}, []);

  //  =========== Edit ======
  const handleEditClose = () => {
    setShowEdit(false);
    setId("");
    setProductId("");
    setQuantity("");
    setAmount("");
  };

  const setEditDataFun = (item) => {
    setProductId(item.product_id);
    setCustomerId(item.customer_id);
    setQuantity(item.quantity);
    setAmount(item.rate);
    setId(item.id);
    setisEditing(true);
  };

  //   ================= Apply Order ==========================
  const saveemp = (e) => {
    setLoading(true);
    e.preventDefault();
    console.log("console date .....,,",date);
    if (!date) {
      alert("Select  Date......!");
      return;
    }
    console.log("orderData:", orderData);
    if ( !Array.isArray(orderData)) {
      console.error("Invalid orderData");
      return;
    }

    const resultArray = orderData.map((item) => {
      if (!item) {
        console.error("Invalid item in orderData:", item);
        return null;
      }
      const productPairs = item.product_quantity.split(",");

      const productData = productPairs.map((pair) => {
        const [productId, quantity] = pair.split("-");
        const formattedDate = dayjs(date).format("DD/MM/YYYY");
        return {
          customer_id: item.customer_id,
          date: item.date,
          employee_id: item.employee_id,
          order_id: item.order_id,
          product_id: productId,
          quantity: parseInt(quantity, 10),
        };
      });

      const formattedDate = dayjs(date).format("DD/MM/YYYY");
      return {
        employee_id: item.employee_id,
        date: formattedDate,
        branch_id: BranchId,
        items: productData, 
      };
    });

    const validResultArray = resultArray.filter((item) => item !== null);
    const resultDataMap = new Map();

    validResultArray.forEach((entry) => {
      const key = `${entry.employee_id}-${entry.date}`;

      if (!resultDataMap.has(key)) {
        resultDataMap.set(key, {
          employee_id: entry.employee_id,
          branch_id: BranchId,
          date: entry.date,
          items: [],
        });
      }

      resultDataMap.get(key).items.push(...entry.items);
    });

    const resultDataArray = Array.from(resultDataMap.values());
    console.log("add resultarray....", resultDataArray[0]);

    axios
      .post(DeliveryDashboardAddOuter, resultDataArray[0])
      .then((res) => {
        console.log("outer data add==>", res.data);
        if (res.data.message == "SAVED") {
          toast.success("Apply Successfully.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          GetOrderdata();
          // setEmployeeId("");
          // setId("");
          setLoading(false);
        } else if (res.data === "DATE_ALREADYEXIST") {
          toast.info("Date already exists.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setLoading(false);
        } else if (res.data === "NOTFOUND") {
          toast.info("Product not found.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setLoading(false);
        } else if (
          res.data.message === "Date cannot be greater than the current date"
        ) {
          toast.error("Date cannot be greater than the current date", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        toast.error("Failed to upload, please try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        
        console.error(err);
      });
      setLoading(false);
  };

  //  ================  inner table save api =====================

  const savedata = (e) => { 
    e.preventDefault();
    setLoading(true);
    if (!quantity || !productId) {
      alert("Please fill in all fields");
      return;
    }
    // const formattedDate = dayjs(date).format('YYYY-MM-DD');

    if (!date) {
      console.error("Invalid date:", date);
      // Handle the invalid date case, for example, by showing an error message
      return;
    }
    const formattedDate = dayjs(date).format("DD/MM/YYYY");
    const obj = {
      employee_id: employeeId,
      product_id: productId,
      quantity: quantity,
      date: formattedDate,
      branch_id: BranchId,
    };
    console.log("FormData===???", obj);

    axios
      .post(`${DeliveryDashboardAdd}${customerId}`, obj)
      .then((res) => {
        console.log("save data ///..", res.data);
        if (res.data.message === "SAVED") {
          console.log("res.data", res.data);
          toast.success("Data Saved Successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          // Reset form fields and reload the data
          Getdata();
          GetOrderdata();
          setProductId("");
          setAmount("");
          setQuantity("");
          setId("");
          setLoading(false);
        } else if (res.data === "ALREADYEXIST") {
          toast.info("Data already exists.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setLoading(false);
        } else if (res.data === "NOTFOUND") {
          toast.info("Product not found.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setLoading(false);
        } else if (res.data === "not_orderAllotment") {
          toast.info("Data not found.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        toast.error("Failed to upload, please try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setLoading(false);
        console.error(err);
      });
  };

  const handleConfirm = () => {
    console.log(`${DeliveryDashboarConfirm}/${date}/${employeeId}/${BranchId}`);

    axios
      .get(`${DeliveryDashboarConfirm}/${date}/${employeeId}/${BranchId}`)
      .then((response) => {
        // Handle the response as needed
        console.log("Confirm API response:", response.data);
        toast.success("Data Confirmed Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        handleClose();
        // You may want to perform additional actions after confirming data
      })
      .catch((error) => {
        console.error("Error confirming data:", error);
        toast.error("Failed to confirm data, please try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      });
  };

  //Getdata Logic
  const Getdata = (e) => {
    if (!customerId) {
      // customerId is not set, handle accordingly
      return;
    }
    if (!date) {
      console.error("Invalid date:", date);
      // Handle the invalid date case, for example, by showing an error message
      return;
    }
    const formattedDate = dayjs(date).format("DD/MM/YYYY");
    const obj = {
      customer_id: customerId,
      date: formattedDate,
      branch_id: BranchId,
    };
    console.log("inner table FormData.....", obj);
    console.log("date inner.....", formattedDate);

    axios
      .post(DeliveryDashboardFindAll, obj)

      .then((res) => {
        console.log("findal inner table", res.data);
        if (res.data !== null) {
          setData(res.data);
        }
        setisEditing(false);
      })
      .catch((err) => {
        // alert("Failed to upload, try again");
        toast.error("Failed to upload, try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.log(err);
      });
  };

  const GetOrderdata = () => {
    if (!date) {
      // Handle the case when date is not set
      return;
    }
    const formattedDate = dayjs(date).format("DD/MM/YYYY");
    setOrderData([]);
    const obj = {
      employee_id: employeeid,
      date: formattedDate,
      branch_id: BranchId,
    };
if(formattedDate === "Invalid Date"){}else{
    axios
      .post(DeliveryDashboardOuterFindAll, obj)
      .then((res) => {

        if (res.data.length === 0) {
          toast.warn("Data Not Allocated...");
        } else if (res.data == "ERROR") {
          toast.error("ERROR");
        } 
        else if (res.data !== null) {
          setOrderData(res.data);
        }
        
        setisEditing(false);
      })
      .catch((err) => {
        // alert("Failed to upload, try again");
        toast.error("Failed to upload, try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.log(err);
      });}
  };

  const updateDeliveryDashboard = () => {
    setLoading(true);
    if (!selectedCustomerName || !productId || !quantity || !customerId) {
      alert("Please fill in all the fields");
      return;
    }
    const formattedDate = dayjs(date).format("DD/MM/YYYY");
    const formData = {
      customer_id: customerId,
      product_id: productId,
      quantity: quantity,
      date: formattedDate,
    };
    console.log("update console obj....", formData);

    axios
      .put(`${DeliveryDashboardUpdate}${id}`, formData)

      .then((res) => {
        console.log("order update res....", res.data);
        if (res.data.message === "UPDATE") {
          toast.success("Data Updated Successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          Getdata();
          GetOrderdata();
          setLoading(false);

          handleEditClose();
        } else if (res.data === "ALREADYEXIST") {
          toast.info("Data already exists.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        // Add debugging information to identify the issue
        console.error("Error while updating Employee:", err);
        setLoading(false);
        if (err.response) {
          console.error("Response data:", err.response.data);
        }

        toast.error("Failed to update data, please try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   if (show) {
  //     // Reload data when the modal is shown
  //     Getdata();
  //   }
  // }, [show, customerId, employeeId, date]);

  //delete data
  const onDelete = (item) => {
    console.log("deleting items...", item);

    axios
      .delete(`${DeliveryDashboardDelete}${item.id}`)
      .then((res) => {
        console.log("Delete response:", res);
        if (res.data === "DELETE") {
          // alert("File Deleted Succesfully");
          toast.success("Data Deleted Succesfuly!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
        handleClose1(false);
        Getdata();
        GetOrderdata();
      })
      .catch((err) => {
        // alert("Failed to upload, try again");
        console.log("Error deleting item:", err);
        toast.error("Failed to upload, try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.log(err);
      });
  };

  let isDeliveryDashFetched = false
  useEffect(() => {
    if (isDeliveryDashFetched) return
    Getdata();
    GetOrderdata();
    isDeliveryDashFetched = true
  }, [customerId, date]);

  //CustomerData Logic
  const Customerdata = (e) => {
    axios
      .get(`${CustomerFindAll}/${BranchId}`)
      .then((res) => {
        if (res.data !== null) {
          setCustomer_master(res.data);
        }
        setisEditing(false);
      })
      .catch((err) => {
        // alert("Failed to upload, try again");
        toast.error("Failed to upload, try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.log(err);
      });
  };

  //Product Logic
  const Productdata = (e) => {
    axios
      .get(`${DeliveryProductFindAll1}/${BranchId}`)
      .then((res) => {
        if (res.data !== null) {
          setProduct_master(res.data);
        }
        setisEditing(false);
      })
      .catch((err) => {
        // alert("Failed to upload, try again");
        toast.error("Failed to upload, try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.log(err);
      });
  };

  //Employeedata Logic
  const Employeedata = (e) => {
    axios
      .get(`${EmployeeFindAll}/${BranchId}`)
      .then((res) => {
        if (res.data !== null) {
          setEmployee_master(res.data);
        }
        setisEditing(false);
      })
      .catch((err) => {
        // alert("Failed to upload, try again");
        toast.error("Failed to upload, try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.log(err);
      });
  };

  let isDeliveryDash1Fetched = false
  useEffect(() => {
    if (isEditing === false) {
      if (isDeliveryDash1Fetched) return
      Getdata();
      GetOrderdata();
      Productdata();
      Customerdata();
      Employeedata();
    }
    isDeliveryDash1Fetched = true
  }, [isEditing]);

  //HEADING FONT ===================

  const headingStyle = {
    fontSize: "27px",
    fontWeight: "bold",
    textAlign: "center",
  };

  const subheadingStyle = {
    color: "rgb(255, 93, 0)", // Assuming this is the color for "text-violet-800"
    fontWeight: 300, // Assuming this is the font weight for "font-[300]"
    textShadow: "3px 1px 5px rgb(180, 180, 180)",
  };
  const uniqueCustomerIds = new Set();

  return (
    <Container >
      <Row>
        <DeliveryHeader />
      </Row>

      
             <Row className="m-0 p-0 pt-2">
        <Col className=' rounded text-center pt-2'
          style={{
            display: "flex",
            justifyContent: "start",
            backgroundColor:"white",
            border:"0px",
            alignItems: "center",
            alignContent:"center",
            color: " rgb(47, 79, 79)",
          }}
        >
          <h6> 
           DASHBOARD
          </h6>
        </Col>
      </Row>

      <Row className="m-0  p-0 pt-2  rounded">
    <Col className="m-0 p-0  rounded py-2" style={{background:"white"}} >
          <Row >
            {/* <Col sm={12} md={8}></Col> */}
            <Col
              sm={12}
              md={4}
              style={{ display: "flex", justifyContent: "end" }}
            >
              <Col className="ps-1 ps-md-2">
               
              <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DemoContainer components={['DatePicker']}>
    <DatePicker
      format="DD-MM-YYYY"
      label="Select Date"
      value={date}
      onChange={(newDate) => {
        console.log("date res", newDate);
        setDate(newDate);
      }}
      slotProps={{ textField: { size: 'small' } }}
    />
  </DemoContainer>
</LocalizationProvider>

              </Col>

              <Col  style={{ display: "flex", alignItems: "center" }}>
                <Button
                  style={{
                    border: "0px",
                    backgroundColor:  "rgb(47, 79, 79)",
                    borderRadius: "15px",
                  }}
                  className="buttonAll py-2 mt-1 px-2 ms-3 fw-1 ms-2 shadow text-light "
                  type="submit"
                  onClick={saveemp}
                  disabled={loading}
                    >{loading ? <Spinner animation='border' size='sm' variant="primary" /> : <div>
                     
                    Apply Order</div>}
                </Button>
              </Col>
            </Col>
          </Row>
           </Col>
          </Row>


          {/* <Row className="m-0  p-0 mt-2  rounded">
    <Col className="m-0 p-0  px-2 rounded" style={{background:"white"}} >

          <div style={{ overflowY: "auto" }}>
            <div style={{ overflowX: "auto" }}>
              <Table
                striped
                bordered
                hover
                size="sm"
                className=" mt-3"
                style={{ textAlign: "center" }}
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        alignItems: "center",
                        backgroundColor: "darkslategray",
                        fontSize: "13px",
                        fontFamily: "sans-serif",
                      }}
                      className="text-center text-light"
                    >
                      Sr.No
                    </th>
                    <th
                      style={{
                        alignItems: "center",
                        backgroundColor: "darkslategray",
                        fontSize: "13px",
                        fontFamily: "sans-serif",
                      }}
                      className="text-center text-light"
                    >
                      Customer
                    </th>
                    <th
                      style={{
                        alignItems: "center",
                        backgroundColor: "darkslategray",
                        fontSize: "13px",
                        fontFamily: "sans-serif",
                      }}
                      className="text-center text-light"
                    >
                      Product & Quantity Regular
                    </th>
                    <th
                      style={{
                        alignItems: "center",
                        backgroundColor: "darkslategray",
                        fontSize: "13px",
                        fontFamily: "sans-serif",
                      }}
                      className="text-center text-light"
                    >
                      Product & Quantity Today
                    </th>
                    <th
                      style={{
                        alignItems: "center",
                        backgroundColor: "darkslategray",
                        fontSize: "13px",
                        fontFamily: "sans-serif",
                      }}
                      className="text-center text-light"
                    >
                      Change
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {orderData.map((item, index) => {
                    const productQuantities = item.productquantity
                      ? item.productquantity.split(",")
                      : [];
                    const backgroundColors = [
                      "Tomato",
                      "cadetblue ",
                      "orchid",
                      "peru",
                      "mediumturquoise",
                      "skyblue",
                      "yellowgreen",
                    ];

                    const productQuantities1 = item.updateproduct
                      ? item.updateproduct.split(",")
                      : [];

                    const groupedProductQuantities = orderData.reduce(
                      (result, order) => {
                        if (!result[order.customer_id]) {
                          result[order.customer_id] = [];
                        }
                        result[order.customer_id].push(order.productquantity);
                        return result;
                      },
                      {}
                    );

                    const groupedProductQuantities1 = orderData.reduce(
                      (result, order) => {
                        if (!result[order.customer_id]) {
                          result[order.customer_id] = [];
                        }
                        result[order.customer_id].push(order.updateproduct);
                        return result;
                      },
                      {}
                    );

                    const customerProductQuantities =
                      groupedProductQuantities[item.customer_id] || [];
                    const customerProductQuantities1 =
                      groupedProductQuantities1[item.customer_id] || [];

                    const flattenedProductQuantities =
                      customerProductQuantities.flat();
                    const flattenedProductQuantities1 =
                      customerProductQuantities1.flat();

                    // Check if customer ID is already processed, skip if it is
                    if (uniqueCustomerIds.has(item.customer_id)) {
                      return null;
                    }

                    // Add the current customer ID to the set to mark it as processed
                    uniqueCustomerIds.add(item.customer_id);

                    return (
                      <tr
                        className="border"
                        style={{
                          width: "100%",
                          justifyContent: "center",
                          alignContent: "center",
                        }}
                        key={index}
                      >
                        <td style={{ textAlign: "center", width: "10%" }}>
                          {index + 1}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            width: "30%",
                          }}
                        >
                          {item.customer_name}
                        </td>
                        <td
                          className="text-center pt-2"
                          style={{
                            textAlign: "center",
                            alignItems: "center",
                            justifyContent: "center",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            width: "40%",
                          }}
                        >
                          {flattenedProductQuantities.map((productQty, idx) => (
                            <span
                              key={idx}
                              style={{
                                backgroundColor:
                                  backgroundColors[
                                    idx % backgroundColors.length
                                  ],
                                padding: "5px 10px",
                                margin: "0px 5px",
                                borderRadius: "10px",
                                color: "black",
                              }}
                            >
                              {productQty.trim()}
                              {idx < flattenedProductQuantities.length - 1 && (
                                <span style={{ margin: "0 5px" }}></span>
                              )}
                            </span>
                          ))}
                        </td>
                        <td
                          className="text-center pt-2"
                          style={{
                            textAlign: "center",
                            alignItems: "center",
                            justifyContent: "center",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            width: "40%",
                          }}
                        >
                          {flattenedProductQuantities1.map(
                            (productQty1, idx) => (
                              <span
                                key={idx}
                                style={{
                                  backgroundColor:
                                    backgroundColors[
                                      idx % backgroundColors.length
                                    ],
                                  padding: "5px 10px",
                                  margin: "0px 5px",
                                  borderRadius: "10px",
                                  color: "black",
                                }}
                              >
                                {productQty1.trim()}
                                {idx <
                                  flattenedProductQuantities1.length - 1 && (
                                  <span style={{ margin: "0 5px" }}></span>
                                )}
                              </span>
                            )
                          )}
                        </td>
                        <td style={{ textAlign: "center", width: "20%" }}>
                          <button
                            className=" m-1"
                            style={{
                              color: "orange",
                              border: "0px",
                              backgroundColor: "transparent",
                            }}
                            onClick={() => handleShow(item)}
                          >
                            <i
                              style={{ color: "rgb(255, 93, 0)" }}
                              className="fa-solid fa-plus"
                            ></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>

          </Col>
          </Row> */}


          <Row className="m-0 mb-5  p-0 mt-2  rounded">
  <Col className="py-3 px-2 rounded" style={{background:"white"}} >
  
      <div style={{ overflowX: "auto" }}>
        <MDBDataTable
          striped
          bordered
          hover
          className="custom-datatable"
          small
          data={{
            columns: [
              {
                label: 'Sr.No',
                field: 'srNo',
                sort: 'asc',
              },
              {
                label: 'Customer Name',
                field: 'customer',
                sort: 'asc',
              },
              {
                label: 'Product & Quantity Regular',
                field: 'productQuantityRegular',
                sort: 'asc',
              },
              {
                label: 'Product & Quantity Today',
                field: 'productQuantityToday',
                sort: 'asc',
              },
              {
                label: 'Change',
                field: 'change',
                sort: 'asc',
              }
            ],
            rows: orderData.map((item, index) => {
              const backgroundColors = [
                "Tomato",
                "cadetblue ",
                "orchid",
                "peru",
                "mediumturquoise",
                "skyblue",
                "yellowgreen",
              ];

              return {
                srNo: index + 1,
                customer: item.customer_name,
                productQuantityRegular: item.productquantity ? item.productquantity.split(",").map((productQty, idx) => (
                  <span
                    key={idx}
                    className="d-inline-block"
                    style={{
                      backgroundColor: backgroundColors[idx % backgroundColors.length],
                      padding: "3px 6px",
                      minWidth: "125px",
                      margin: "4px 5px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  >
                    {productQty.trim()}
                    {idx < item.productquantity.split(",").length - 1 && (
                      <span style={{ margin: "0 5px" }}></span>
                    )}
                  </span>
                )) : null,
                productQuantityToday: item.updateproduct ? item.updateproduct.split(",").map((productQty1, idx) => (
                  <span
                  key={idx}
                    className="d-inline-block"
                    style={{
                      backgroundColor: backgroundColors[idx % backgroundColors.length],
                      padding: "3px 6px",
                      minWidth: "125px",
                      margin: "4px 5px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  >
                    {productQty1.trim()}
                    {idx < item.updateproduct.split(",").length - 1 && (
                      <span style={{ margin: "0 5px" }}></span>
                    )}
                  </span>
                )) : null,
                change: (
                  <button
                    className="m-1"
                    style={{
                      color: "orange",
                      border: "0px",
                      backgroundColor: "transparent",
                    }}
                    onClick={() => handleShow(item)}
                  >
                    <i
                      style={{ color: "rgb(255, 93, 0)" }}
                      className="fa-solid fa-plus"
                    ></i>
                  </button>
                )
              };
            })
          }}
        />
      </div>

  </Col>
</Row>



        {/* ========================== Modal ============= */}
        <Modal
          className="shadow rounded"
          size="xl"
          show={show}
          onHide={handleClose}
        >
      
          <Modal.Body>
            <Form encType="multipart/form-data">
              <Row className="m-0 p-0">
                <Col sm={12} md={4} className="mt-3">
                  <Form.Label>
                    <h6>
                      <b>Customer :</b>
                    </h6>
                  </Form.Label>
                  <TextField
                    size="small"
                    type="text"
                    readOnly
                    value={selectedCustomerName}
                    style={{ width: "100%" }} 
                  />
                </Col>

                <Col sm={12} md={4} className="mt-3">
                  <Form.Label>
                    <h6>
                      <b>Product :</b>
                    </h6>
                  </Form.Label>
                 
                  <Autocomplete
                    disablePortal
                    size="small"
                    id="combo-box-demo"
                    options={product_master}
                    getOptionLabel={(option) => option.product_name}
                    value={
                      product_master.find(
                        (item) => item.product_id === productId
                      ) || null
                    }
                    onChange={(e, newValue) =>
                      setProductId(newValue ? newValue.product_id : "")
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Product"
                        style={{ width: "100%" }}
                      />
                    )} 
                  />
                  {/* )} */}
                </Col>

                <Col sm={12} md={4} className="mt-3 mb-3">
                  <Form.Label>
                    <h6>
                      <b>Quantity :</b>
                    </h6>
                  </Form.Label>
                  <TextField
                    size="small"
                    type="number"
                    placeholder="Enter Quantity"
                    pattern="[0-9]"
                    required
                    value={quantity}
                    onChange={(e) => setQuantity(e.target.value)}
                    style={{ width: "100%" }} 
                  />
                </Col>
              </Row>
              <Row className="mt-2 mb-3">
                <Col style={{ display: "flex", justifyContent: "center" }}>
                  {isEditing === false ? (
                    <Button
                      style={{
                        border: "0px",
                        backgroundColor: "rgb(47, 79, 79)",
                        borderRadius: "15px",
                      }}
                      className="py-2 px-3 mx-2 shadow text-light"
                      type="submit"
                      onClick={savedata}
                    disabled={loading}
                    >{loading ? <Spinner animation='border' size='sm' variant="primary" /> : <div>
                     
                      &nbsp;Save</div>}
                    </Button>
                  ) : (
                    <Button
                      style={{
                        border: "1px solid rgb(47, 79, 79)",
                        backgroundColor: "rgb(47, 79, 79)",
                        borderRadius: "15px",
                      }}
                      className="py-2 px-3 mx-2 shadow text-light"
                      type="submit"
                      onClick={updateDeliveryDashboard}
                      disabled={loading}
                    >{loading ? <Spinner animation='border' size='sm' variant="primary" /> : <div>
                     
                      &nbsp;Update</div>}
                      
                    </Button>
                  )}
                </Col>
              </Row>
            </Form>

            <div style={{ overflowY: "auto" }}>
              <div style={{ overflowX: "auto" }}>
                <Table
                  striped
                  bordered
                  hover
                  size="sm"
                  className="shadow mt-2"
                  style={{ textAlign: "center" }}
                >
                  <thead>
                    <tr>
                      <th
                        style={{
                          alignItems: "center",
                          backgroundColor: "darkslategray",
                          fontSize: "13px",
                          fontFamily: "sans-serif",
                        }}
                        className="text-center text-light"
                      >
                        Sr.No
                      </th>
                      <th
                        style={{
                          alignItems: "center",
                          backgroundColor: "darkslategray",
                          fontSize: "13px",
                          fontFamily: "sans-serif",
                        }}
                        className="text-center text-light"
                      >
                        Customer
                      </th>
                      <th
                        style={{
                          alignItems: "center",
                          backgroundColor: "darkslategray",
                          fontSize: "13px",
                          fontFamily: "sans-serif",
                        }}
                        className="text-center text-light"
                      >
                        Product
                      </th>
                      <th
                        style={{
                          alignItems: "center",
                          backgroundColor: "darkslategray",
                          fontSize: "13px",
                          fontFamily: "sans-serif",
                        }}
                        className="text-center text-light"
                      >
                        Quantity
                      </th>
                      <th
                        style={{
                          alignItems: "center",
                          backgroundColor: "darkslategray",
                          fontSize: "13px",
                          fontFamily: "sans-serif",
                        }}
                        className="text-center text-light"
                      >
                        Edit
                      </th>
                      <th
                        style={{
                          alignItems: "center",
                          backgroundColor: "darkslategray",
                          fontSize: "13px",
                          fontFamily: "sans-serif",
                        }}
                        className="text-center text-light"
                      >
                        Delete
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => {
                      return (
                        <tr className="border">
                          <td style={{ textAlign: "center" }}>{index + 1}</td>
                          <td style={{ textAlign: "center" }}>
                            {item.customer_name}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.product_name}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.quantity}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <button
                              className=" m-1"
                              style={{
                                color: "orange",
                                border: "0px",
                                backgroundColor: "transparent",
                              }}
                              onClick={() => setEditDataFun(item)}
                            >
                              <i class="fa-solid fa-pen-to-square"></i>
                            </button>
                          </td>

                          <td style={{ textAlign: "center" }}>
                            <button
                              className=" m-1"
                              style={{
                                color: "red",
                                border: "0px",
                                backgroundColor: "transparent",
                              }}
                              onClick={() => handleShow1(item)}
                            >
                              <i className="fa-solid fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer
            className="m-0 p-0"
            style={{ backgroundColor: " rgb(47, 79, 79)" }}
          >
            {/* <Button style={{ color: "white", backgroundColor: "darkslategray", border: "2px solid darkslategray", borderRadius: "15px" }} onClick={handleConfirm}>
              Confirm
            </Button> */}

            <Button
              style={{
                color: "black",
                backgroundColor: "white",
                border: "2px solid white",
                borderRadius: "15px",
              }}
              onClick={handleClose}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ============= Delete Modal ========= */}

        <Modal show={show1} onHide={handleClose1}>
          <Modal.Header
            style={{ backgroundColor: " rgb(47, 79, 79)", color: "White" }}
          >
            <Modal.Title>
              <i
                className="fa-solid fa-trash"
                style={{ color: "rgb(254, 105, 129)" }}
              ></i>{" "}
              Delete Confirmation
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete this item?</Modal.Body>
          <p className="text-end">
            <Button
              className="mx-2"
              style={{
                color: "black",
                backgroundColor: "white",
                border: "2px solid darkslategray",
                borderRadius: "15px",
              }}
              onClick={handleClose1}
            >
              Cancel
            </Button>
            <Button
              style={{
                border: "1px solid darkslategray",
                backgroundColor: "darkslategray",
                borderRadius: "15px",
              }}
              className="py-2 px-3 mx-2  shadow text-light"
              onClick={() => onDelete(itemToDelete)}
            >
              Delete
            </Button>
          </p>
        </Modal>
    </Container>
  );
};

export default DeliveryDashboard;
